module.exports = __webpack_public_path__ + "img/imgXharra-6.532eac63.png";